import React from "react";
import Container from "../components/Todos/Container";

const TodoPage = () => {
  return (
    <div className="todo-page">
      <Container />
    </div>
  );
};

export default TodoPage;
